import { selectBasketCheckPriceItem, selectBasketItem, updateBasketItem } from '../basketSlice'
import InsurancePopup, { InsuranceState } from './InsurancePopup'
import { useReduxDispatch, useReduxSelector } from 'store'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import usePopupState from 'hooks/usePopupState'
import { useParams } from 'react-router-dom'
import { displayPrice } from 'utils/string'
import React from 'react'
import './style.scss'

const Insurance: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const { insurance } = useReduxSelector(state => selectBasketItem(state, id))
  const checkPrice = useReduxSelector(state => selectBasketCheckPriceItem(state, id))
  const { popup, openPopup } = usePopupState<{ type: 'insurance', body?: InsuranceState }>()

  const dispatch = useReduxDispatch()
  const { t } = useTranslation('basket')

  return (
    <div className='orderInfoButton'>
      {popup?.type === 'insurance' && <InsurancePopup
        previousValues={popup.body}
        data={checkPrice.insurance}
        updateValues={values => {
          dispatch(updateBasketItem({ identifier: id, values: { insurance: values } }))
        }}
      />}
      <div className='title'>
        <div>
          <span>{t('insurance')}</span>
        </div>
      </div>

      {insurance
        ? <div className='orderInfo__item --selected'>
          <div className='orderInfo__item__icon'>
            <i className='icon icon--insurance' />
          </div>
          <div className='orderInfo__item__content'>
            <div className='orderInfo__item__title'>{t('variant')}: {insurance.variantName}</div>
            <div className='orderInfo__item__scope'>{t('insuranceSum')}: {insurance.v ? displayPrice(insurance.v) : ''}</div>
            <div className='orderInfo__item__scope'>{t('insurancePremium')}: {insurance.grossPrice ? displayPrice(insurance.grossPrice) : ''}</div>
          </div>
          <ArrowBtn
            showArrow={false}
            className='--secondary'
            text={t('change')}
            action={() => {
              openPopup({ type: 'insurance', body: insurance })
            }}
          />
        </div>
        : <div className='orderInfo__button'>
          <button
            className='button --coupon'
            onClick={() => {
              openPopup({ type: 'insurance' })
            }}>
            {t('addInsurance')}
          </button>
        </div>}
    </div>
  )
}

export default Insurance